import styled from 'styled-components';
import Documents from './Documents';
import { colorSchema, media } from 'utils/style';

export default styled(Documents)`
  background: ${colorSchema('white')};
  border-top: 1px solid ${colorSchema('grey700')};
  height: auto;
  min-height: 100%;
  margin: 0 -1rem;
  padding: 0 1rem;

  ${media.greaterThan('tablet')`
    border: 0;
    margin: 0;
    padding: 0;
  `}

  .documents {
    display: grid;
    flex-direction: column;
    margin: 0 0.6rem;
    grid-gap: 12px;
    grid-template-columns: repeat(4, 1fr);
    flex-direction: column;

    ${media.greaterThan('tablet')`
      grid-template-columns: repeat(12, 1fr);
      max-width: 1128px;
      margin: 0 auto;
    `}

    &__container {
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        grid-column: 1 / span 12;
        padding: 0 2rem;
      `}
    }

    &__loading,
    &__error {
      display: flex;
      padding: 2rem 0;
      height: 100vh;
      justify-content: center;
      grid-column: 1 / span 4;
      grid-row: 1;

      ${media.greaterThan('tablet')`
        height: 100vh;
        grid-column: 1 / span 12;
      `}
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-size: 2.4rem;
      font-weight: normal;
      margin: 2.3rem 0 1.6rem 0;

      ${media.greaterThan('tablet')`
        border-bottom: 1px solid ${colorSchema('grey200')};
        padding-bottom: .6rem;
        margin: 2.3rem 0 3.2rem 0;
      `}
    }

    &__filters {
      margin-bottom: 2.4rem;
      ${media.greaterThan('tablet')`
        margin-bottom: 4rem;
      `}
      label {
        &:first-child {
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
        }
        &:last-child {
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
        }
      }
    }

    &__list,
    &__sublist {
      margin-bottom: 2.4rem;
    }

    &__sublist {
      ${media.greaterThan('tablet')`
        border-bottom: 1px solid ${colorSchema('grey300')};
        margin-bottom: 4rem;
      `}
    }

    &__list-title,
    &__list-label {
      color: ${colorSchema('grey700')};
      font-size: 1.6rem;
      font-weight: bold;
      margin: 0 0 0.8rem;
      text-transform: uppercase;
      ${media.greaterThan('tablet')`
        margin: 0;
      `}
    }

    &__list-label {
      ${media.greaterThan('tablet')`
        display: flex;
        align-items: center;
      `}
    }

    &__vehicle-icon {
      display: none;
      ${media.greaterThan('tablet')`
        display: block;
        margin-right: 1.6rem;
        svg {
          fill: ${colorSchema('grey500')};
        }
      `}
    }

    &__list-title {
      &--hide {
        display: none;
        ${media.greaterThan('tablet')`
          display: block;
          margin-bottom: 1.6rem;
      `}
      }
    }

    &__sublist-columns {
      display: none;
      justify-content: flex-end;
      margin-bottom: 0.4rem;
      ${media.greaterThan('tablet')`
        display: flex;
      `}
    }

    &__column {
      color: ${colorSchema('grey700')};

      font-size: 1.4rem;

      &--state {
        margin-right: 44.7rem;
      }

      &--expire {
        margin-right: 6.2rem;
      }
    }
  }
`;
